export const CODELOGIC_UI_PATH = window['CODELOGIC_UI_PATH'] as '{{codelogic-base-path}}';

export const CODELOGIC_API_BASE_URL = window['CODELOGIC_API_BASE_URL'] as '{{codelogic-server}}' || '/codelogic/server';
